import { Image, Nav, Navbar } from "react-bootstrap";

import Flag from '../images/BandieraItalia.svg'
import { LinkContainer } from "react-router-bootstrap";
import React from "react";

const styleScrittaAgu = {
    maxHeight: "15vh",
    padding: 0,
    margin: 0,
};

const styleNavBar = {
    padding: "0",
    position: "sticky",
};

const styleNavBackground = {
    background: "black", // Black background
    width: "100%", // Full page width
    display: "flex",
    flexDirection: "column", // Align items vertically
    paddingLeft: "80px",
};

const styleNavItems = {
    color: "white", // White text color
};
const activeStyleNavItems = {
    textDecoration: "underline white"
};

const styleTest = {
    flexDirection: "column", // Align items vertically
    alignItems: "flex-start", // Align items to the left
};

const selectPage = () => {
    window.scrollTo(0, 0);
}

export const NavigationBar = () => (
    <Navbar bg="white" expand="lg" sticky="top" style={styleNavBar}>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" style={styleTest}>
            <Image src="/images/scrittaAgu.png" style={styleScrittaAgu} />
            <div style={styleNavBackground} className="mt-auto">
                <Nav>
                    <LinkContainer to="/en" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link >Welcome</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/en/history" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link>History</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/en/vineyards" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link>Vineyards</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/en/wines" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link>Wines</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/en/contact" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link>Contact</Nav.Link>
                    </LinkContainer>
                    <a href="https://agu.sumupstore.com/prodotti">Shop</a>

                    <LinkContainer className="ms-auto" to="/" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link><Image src={Flag} style={{ width: '25px' }} alt="Bandiera Italia" /> Ita</Nav.Link>
                    </LinkContainer>
                </Nav>
            </div>
        </Navbar.Collapse>
    </Navbar>
);